export const GENERAL = {
    CONTEXT: 'SET_CONTEXT',
  }

export const SetContext = ( payload) => ({
    type: GENERAL.CONTEXT,
    payload
})